<div class="urs" role="status" aria-busy="true" aria-label="Loading menu">
  <header class="urs__header">
    <p-skeleton width="6.5rem" height="2.25rem" borderRadius="10px" />
    <div class="urs__row urs__row--sm">
      @for (_ of headerActions; track $index) {
        <p-skeleton width="2.75rem" height="2.75rem" shape="circle" />
      }
    </div>
  </header>

  <div class="urs__banner">
    <p-skeleton width="100%" height="100%" borderRadius="0" styleClass="urs__fill" />
    <div class="urs__banner-overlay urs__stack">
      <p-skeleton width="55%" height="2rem" borderRadius="8px" />
      <p-skeleton width="35%" height="1.1rem" borderRadius="6px" />
    </div>
  </div>

  <div class="urs__body">
    <div class="urs__layout">
      <aside class="urs__sidebar urs__stack">
        <p-skeleton width="100%" height="3.25rem" borderRadius="12px" />
        <p-skeleton width="100%" height="2.75rem" borderRadius="10px" />

        @for (group of filterGroups; track $index) {
          <div class="urs__stack urs__stack--tight urs__filter-group">
            <p-skeleton [width]="group.labelWidth" height="1rem" borderRadius="6px" />
            @for (labelWidth of group.optionLabelWidths; track $index) {
              <div class="urs__row urs__row--sm">
                <p-skeleton width="1.25rem" height="1.25rem" borderRadius="4px" />
                <p-skeleton [width]="labelWidth" height="0.9rem" borderRadius="6px" />
              </div>
            }
          </div>
        }
      </aside>

      <section class="urs__main urs__stack urs__stack--loose">
        @for (_ of categoryIndices; track $index) {
          <div class="urs__stack">
            <div class="urs__stack urs__stack--tight">
              <p-skeleton width="14rem" height="1.6rem" borderRadius="8px" />
              <p-skeleton width="22rem" height="0.95rem" borderRadius="6px" styleClass="urs__hide-sm" />
            </div>

            <div class="urs__grid">
              @for (_ of productCardIndices; track $index) {
                <ng-container *ngTemplateOutlet="productCard" />
              }
            </div>
          </div>
        }
      </section>
    </div>
  </div>
</div>

<ng-template #productCard>
  <article class="urs__card">
    <div class="urs__card-media">
      <p-skeleton width="100%" height="100%" borderRadius="0" styleClass="urs__fill" />
      <p-skeleton width="2.9rem" height="2.9rem" borderRadius="12px" styleClass="urs__card-fab" />
    </div>
    <div class="urs__card-body urs__stack urs__stack--tight">
      <div class="urs__row">
        <p-skeleton width="60%" height="1.05rem" borderRadius="6px" />
        <p-skeleton width="3rem" height="1.05rem" borderRadius="6px" />
      </div>
      <p-skeleton width="95%" height="0.8rem" borderRadius="6px" />
      <p-skeleton width="80%" height="0.8rem" borderRadius="6px" />
      <div class="urs__row urs__row--sm">
        <p-skeleton width="3.5rem" height="1.4rem" borderRadius="999px" />
        <p-skeleton width="3rem" height="1.4rem" borderRadius="999px" />
      </div>
    </div>
  </article>
</ng-template>
